module.exports = __webpack_public_path__ + "static/img/6a.f61c8d7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/6a.jpg
// module id = nxOZ
// module chunks = 0